import React from 'react';
import { Container } from 'semantic-ui-react';
import './Footer.css';

const Footer = () => {
    const currentYear = new Date().getFullYear();

    return (
        <footer className="app-footer">
            <Container fluid>
                <div className="footer-content">
                    <p className="footer-copyright">
                        © {currentYear} CrashPlan. All rights reserved.
                    </p>
                </div>
            </Container>
        </footer>
    );
};

export default Footer;

